export class MentoringChartsModel {
    studentStatusChart: any = {};
    studentStatusChartYearWise: any = {};

}